import Spinner from "react-bootstrap/Spinner";
import styles from "./loaderStyle.module.scss";

function OverlayLoader(props) {
  return (
    <div
      className={
        props.loading ? styles.spin_Log_overlay : styles.spin_Log_overlayOff
      }
    >
      <Spinner animation="border" variant="primary" />
    </div>
  );
}
export default OverlayLoader;



